export const productionConstants = {
    GET_MANUFACTURED_PRODUCTS_REQUEST: 'GET_MANUFACTURED_PRODUCTS_REQUEST',
    GET_MANUFACTURED_PRODUCTS_SUCCESS: 'GET_MANUFACTURED_PRODUCTS_SUCCESS',
    GET_MANUFACTURED_PRODUCTS_FAILURE: 'GET_MANUFACTURED_PRODUCTS_FAILURE',
    CLEAR_MANUFACTURED_PRODUCTS: 'CLEAR_MANUFACTURED_PRODUCTS',
};
